import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const KanbanIndex = () => import('./pages/KanbanIndex.vue');
const KanbanSettings = () => import('./pages/KanbanSettings.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.KANBAN_BOARD,
  permissions: ['administrator', 'agent'],
};

const adminMeta = {
  featureFlag: FEATURE_FLAGS.KANBAN_BOARD,
  permissions: ['administrator', 'agent'],
};

const kanbanRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      component: KanbanIndex,
      name: 'kanban_index',
      meta,
    },
    {
      path: frontendURL('accounts/:accountId/settings/kanban'),
      component: KanbanSettings,
      name: 'kanban_settings',
      meta: adminMeta,
    },
  ],
};

export default kanbanRoutes;
